<div class="form-card">
  <img [src]="img" alt="" class="offer-img">
  <div class="offer-infos">
    <ng-casto-btn label="J'en profite" class="yellow" (click)="goToUrl()"></ng-casto-btn>
    <p class="offer-title">{{title}}</p>
    <p class="offer-subtitle">{{subtitle}}</p>
    <p class="offer-description">{{description}}</p>
  </div>
</div> 